export const textBreakLine = (text, callBack) => {
  return text.split("\n").map((line, idx) => callBack && callBack(line, idx));
};
